export *from './insa-main-window/insa-main-window.component';
export *from './insa-main-widgets/mainWindowBarChart.component';
export *from './insa-main-widgets/mainWindowDonutChart.component';
export *from './insa-main-widgets/mainWindowFavorites.component';
export *from './insa-main-widgets/mainWindowLastUsed.component';
export *from './insa-main-widgets/mainWindowSearch.component';
export *from './insa-main-widgets/mainWindowSettings.component';
export *from './insa-main-widgets/mainWindowWelcome.component';
export *from './insa-main-widgets/menuEntry.component';
export *from './insa-main-widgets/newHome.component';
export *from './insa-main-widgets/taskList.component';


// WEBPACK FOOTER //
// ./app/insa-components/insa-main/index.ts